import React from 'react';
import { getColorFromName, getInitials } from './utils/letterAvatar';
import './LetterAvatar.css';

const LetterAvatar = ({ name, size = 40, className = '' }) => {
    const initials = getInitials(name);
    const backgroundColor = getColorFromName(name);
    // Determine if this is a job-logo avatar
    const isJobLogo = className.includes('job-logo');
    const isJobLogoSquare = className.includes('job-logo-square');
    return (
        <div 
            className={`letter-avatar ${className}`}
            style={{
                backgroundColor: backgroundColor,
                width: size,
                height: size,
                fontSize: isJobLogoSquare ? size * 0.45 : (isJobLogo ? size * 0.55 : size * 0.4),
                fontWeight: isJobLogo || isJobLogoSquare ? 900 : 600,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textTransform: 'uppercase',
                userSelect: 'none',
                padding: 0,
                margin: 0,
                borderRadius: isJobLogoSquare ? 0 : (isJobLogo ? '50%' : '50%'),
            }}
        >
            <span style={{
                width: '100%',
                height: '100%',
                margin: 0,
                padding: 0,
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: (isJobLogoSquare || isJobLogo) ? 'translateY(-2px)' : undefined,
            }}>{initials}</span>
        </div>
    );
};

export default LetterAvatar; 